import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import statementUtils from './statement-utils'
import { IStatement, Statement } from '../../../model/statement'
import statementStore from '../statement-store'
import setMeta from './set-meta'
import fetchStatements from './fetch-statements'
import { IReference, Reference } from '@/model/reference';

export default async function addStatement(context: BareActionContext<StatementState, RootState>)
{
    let form = statementStore.state.statementForm
    let statement: IStatement = new Statement()
    statement.text = statementStore.state.statementForm.text
    if(form.referenceUrl || form.referenceDesc) {
        let reference: IReference = new Reference()
        reference.url = form.referenceUrl
        reference.description = form.referenceDesc
        form.references.push(reference)
    }
    if(
        form.tag && 
        form.tags.indexOf(form.tag) < 0
    ) {
        form.tags.push(form.tag)
    }
  
    statementUtils.statementService.addStatement(statement, form.tags, form.references).then((result: any) => {
        statementStore.commitResetStatementForm({ })
        fetchStatements(context)
    })

    return
}
